import { Container } from "./styles";
import githubIcon from "../../assets/github-icon.svg";
import externalLinkIcon from "../../assets/external-link-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function Portfolio() {
    return (
        <Container id="portfolio">
            <h2>my portfolio</h2>

            <div className="projects">
                <ScrollAnimation animateIn="flipInX">
                    <div className="project">
                        <header>
                            <svg
                                width="50"
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#23ce6b "
                                stroke-width="1"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <title>Folder</title>
                                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                            </svg>
                            <div className="project-links">
                                <a
                                    href="https://github.com/devanandan5/shopping-cart-"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src={githubIcon} alt="GitHub" />
                                </a>
                            </div>
                        </header>
                        <div className="body">
                            <h3>Sopping Cart</h3>
                            <p>
                            A web application made for online shopping.
                            </p>
                        </div>
                        <footer>
                            <ul className="tech-list">
                                <li>Node</li>
                                <li>Express</li>
                                <li>Mongo</li>
                                <li>HandleBars</li>
                            </ul>
                        </footer>
                    </div>
                </ScrollAnimation>

                <ScrollAnimation animateIn="flipInX">
                    <div className="project">
                        <header>
                            <svg
                                width="50"
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#23ce6b "
                                stroke-width="1"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <title>Folder</title>
                                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                            </svg>
                            <div className="project-links">
                                <a
                                    href="https://github.com/devanandan5/ivar_developers/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src={githubIcon}
                                        alt="githubIcon"
                                    />
                                </a>
                            </div>
                        </header>
                        <div className="body">
                            <h3>ivar Developers</h3>
                            <p>
                                Company website sample. Others are private in github due to copyright issues of company.
                            </p>
                        </div>
                        <footer>
                            <ul className="tech-list">
                                <li>Html</li>
                                <li>Css</li>
                                <li>JavaScript</li>
                            </ul>
                        </footer>
                    </div>
                </ScrollAnimation>
            </div>
        </Container>
    );
}
